import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".dataset", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { attrs: {
    class: this.attr("selected") ? "selected dataset-holder" : "dataset-holder",
    elref: "datasetCard"
  } }, /* @__PURE__ */ jsx("div", { sel: ".image-holder" }, /* @__PURE__ */ jsx("div", { sel: ".card-image", attrs: {
    class: "".concat(this.attr("img-name"))
  } }), /* @__PURE__ */ jsx("div", { sel: ".sub-text" }, this.attr("text")))));
}
